/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum IntegrationType {
  GOOGLE_CALENDAR = 'google_calendar',
  OUTLOOK_CALENDAR = 'outlook_calendar',
  SALESFORCE = 'salesforce',
  PIPEDRIVE = 'pipedrive',
  SLACK = 'slack',
  NOTION = 'notion',
  TEAMS = 'teams',
  SLACK_CHANNEL = 'slack_channel',
  CONFLUENCE = 'confluence',
  JIRA = 'jira',
  LINEAR = 'linear',
}
